module.exports = __webpack_public_path__ + "static/media/pharmacore team.f4b7aa8f.jpg";